// config
import * as http from 'utils/http';
import config from 'config';

const sendTicketUpdate = async ({ id, dto }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/${id}/updates/`, dto);
};

export default sendTicketUpdate;
